export default {
  'error.user_cant_get_data_recent_request':
    'Please wait at least 24 hours before making another retrieve data request.',
  'error.auth_too_many_attempts':
    'Please wait at least 3 hours before submitting another question.',
}
